// Shared browser/server upload conventions.
export const PROFILE_IMAGE_MAX_BYTES = 3 * 1024 * 1024;
export const PROFILE_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];
export const PROFILE_IMAGE_COMPRESSION = {
  maxSizeMB: 1,
  maxWidthOrHeight: 800,
  useWebWorker: true,
  fileType: "image/jpeg",
};
